export enum ColumnType {
    TEXT = 'string',
    LINK = 'link',
    NUMERIC = 'numeric',
    ROW_ACTION = 'rowAction'
}
